import { render, staticRenderFns } from "./ManageOperations.vue?vue&type=template&id=6bc2d07e&"
import script from "./ManageOperations.vue?vue&type=script&lang=js&"
export * from "./ManageOperations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports